/**
 * CheckboxFieldType — flaga tak/nie. Storage: PG BOOLEAN.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function CheckboxInput({ field, value, onChange, disabled }: FieldInputProps) {
  const checked = value === true || value === 'true';
  return (
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        data-testid={`field-${field.slug}-input`}
        className="h-4 w-4 rounded border-border-primary text-accent-600 focus:ring-accent-500"
      />
      <span className="text-text-secondary">{field.description ?? field.name}</span>
    </label>
  );
}

export const CheckboxFieldType: FieldTypeDefinition = {
  type: 'checkbox',
  renderInput: (props) => <CheckboxInput {...props} />,
  renderCell: (_field, value) => (value === true || value === 'true' ? 'Tak' : 'Nie'),
  defaultValue: false,
};
